import axios from 'axios';

export default {
    namespaced: true,

    state: {
        latestUpdateNotification: localStorage.getItem('latestUpdateNotification'),
        latestEnforcedUpdateNotification: localStorage.getItem('latestEnforcedUpdateNotification'),
    },
    getters: {
        latestUpdateNotification (state) {
            return state.latestUpdateNotification
        },
        latestEnforcedUpdateNotification (state) {
            return state.latestEnforcedUpdateNotification
        }
    },
    mutations: {
        SET_LATEST_UPDATE_NOTIFICATION (state, value) {
            state.latestUpdateNotification = value;
        },
        SET_LATEST_ENFORCED_UPDATE_NOTIFICATION (state, value) {
            state.latestEnforcedUpdateNotification = value;
        },
    },

    actions: {

        getLatestUpdateNotification ({ commit }) {
            return axios.get('/api/update_notification/latest?enforce_planning_updates=0').then((response) => {
                commit('SET_LATEST_UPDATE_NOTIFICATION', response.data.data)
            }).catch(() => {
                commit('SET_LATEST_UPDATE_NOTIFICATION', false)
            })
        },

        getLatestEnforcedUpdateNotification ({ commit }) {
            return axios.get('/api/update_notification/latest?enforce_planning_updates=1').then((response) => {
                commit('SET_LATEST_ENFORCED_UPDATE_NOTIFICATION', response.data.data)
            }).catch(() => {
                commit('SET_LATEST_ENFORCED_UPDATE_NOTIFICATION', false)
            })
        },
    }
}
